import axios from 'axios';
import { errorHandler } from '../utils/errorHandler';

export const uploadImage = async (image) => {
  const form = new FormData();
  await form.append('files', image);

  try {
    const res = await axios.post('/upload', form);
    if (res.data) return res.data;
  } catch (error) {
    errorHandler(error);
  }
};
